export const FRAUDSTER_TOOL_KYC = 'KYC';

export const FRAUDSTER_BYPASSING_TOOL_CHECKOUT = 'CHECKOUT';
export const FRAUDSTER_BYPASSING_TOOL_APPLEPAY = 'APPLEPAY';
export const FRAUDSTER_BYPASSING_TOOL_GOOGLEPAY = 'GOOGLEPAY';



// WEBPACK FOOTER //
// ./src/constants/fraud.js